export { wrapRootElement } from "./src/root"
require("./static/prism/prism.css")
